import { collection, doc, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "src/firebase";
import { UserSpaceSwitchHistory } from "../types/user-space-switch-history.entity";

export const USER_SPACES_SWITCH_HISTORY_COLLECTION = "user_spaces_switch_history";

class UserSpaceSwitchHistoryRepository {
  async getByUserId(userId: string): Promise<UserSpaceSwitchHistory[]> {
    const historyQuery = query(
      collection(doc(db, "users", userId), USER_SPACES_SWITCH_HISTORY_COLLECTION),
      orderBy("createdAt", "desc")
    );

    const snapshot = await getDocs(historyQuery);

    return snapshot.docs.map(
      (historyDoc) =>
        ({
          id: historyDoc.id,
          ...historyDoc.data(),
        }) as UserSpaceSwitchHistory
    );
  }
}

export const userSpaceSwitchHistoryRepository = new UserSpaceSwitchHistoryRepository();
